import { withStyles } from '@material-ui/core/styles';
import FilterChips from './FilterChips';
import styles from './FilterChips.styles';

export default withStyles(styles)(FilterChips);
